import { createContext, useEffect, useReducer } from "react";
import PropTypes from "prop-types";
import { getUserInfoDetails } from "../services/User";
import { useTranslation } from "react-i18next";
import useToast from "../hooks/useToast";
import { useNavigate } from "react-router-dom";

const initialState = {
  userDetails: {},
  schoolDetails: {},
  teacherComponentMounted: false,
  gradeComponentMounted: false,
  isLoading: true,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "userDetails":
      return { ...state, userDetails: action.payload };
    case "schoolDetails":
      return { ...state, schoolDetails: action.payload };
    case "teacherComponentMounted":
      return { ...state, teacherComponentMounted: action.payload };
    case "gradeComponentMounted":
      return { ...state, gradeComponentMounted: action.payload };
    case "isLoading":
      return { ...state, isLoading: action.payload };
    default:
      return { ...state };
  }
};

export const MasterDataContext = createContext();

const MasterDataContextProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const toast = useToast();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const token = localStorage.getItem("abjadToken");

  useEffect(() => {
    if (token) getUserInfo();
  }, [token]);

  const getUserInfo = async () => {
    dispatch({ type: "isLoading", payload: true });
    try {
      const response = await getUserInfoDetails();
      if (
        response &&
        response._statusCode === 200 &&
        response._entity._userType === "SCHOOL_PRINCIPAL"
      ) {
        const {
          _email: email,
          _userCode: userId,
          _schoolCode: schoolId,
          _lastName: lastName,
          _firstName: firstName,
          _schoolName: schoolName,
          _mobileNumber: mobileNumber,
          _academicEnd: academicEndDate,
          _academicStart: academicStartDate,
        } = response._entity;
        dispatch({
          type: "userDetails",
          payload: {
            email,
            userId,
            firstName,
            lastName,
            mobileNumber,
          },
        });
        dispatch({
          type: "schoolDetails",
          payload: {
            schoolId,
            schoolName,
            academicEndDate,
            academicStartDate,
          },
        });
      } else throw response;
    } catch (error) {
      toast({
        label: t("Error"),
        message: t("Unauthorized"),
        rtl: i18n.dir() === "rtl",
        type: "error",
      });

      const restoreId = localStorage.getItem("restoreId");
      localStorage.clear();
      if (restoreId) localStorage.setItem("restoreId", restoreId);
      navigate("/login");
      console.log({ error });
    }
    dispatch({ type: "isLoading", payload: false });
  };

  return (
    <MasterDataContext.Provider value={{ state, dispatch }}>
      {props.children}
    </MasterDataContext.Provider>
  );
};

MasterDataContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MasterDataContextProvider;
